import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  Modal,
  Button,
  Form,
  Icon,
  Message,
  Radio,
  Table,
  Card,
  Container,
  Checkbox,
  TextArea,
  IconGroup,
} from "semantic-ui-react";
import tdvs from "../../../api2/tdvs";
import { AppContext } from "../../../context/appContext";
import { NewApi } from "../../../api/consts";
import axios from "axios";
import { useHistory } from "react-router-dom";

const OnlineMarksDigiVal = (props) => {
  const params =
    props && props.match && props.match.params
      ? props.match.params
      : props || {};
  let qpcode = params.qpcode || "";
  let regcode = params.regcode || "";
  let valno = params.valno || "";
  const history = useHistory();
  const fteachcode = sessionStorage.getItem("fteachcode") || "";

  const { teachcode, err_msg, load } = useContext(AppContext);
  const [loader, setLoader] = load || [false, () => {}];
  const [error, dispatch_err] = err_msg || [null, () => {}];

  const [filename, setFileNames] = useState([]);
  const [filepath, setFilepath] = useState("");
  const [qpSchemepath, setQpSchemePath] = useState({});
  const [parts, setParts] = useState([]);
  const [omrmarks, setOmrMarks] = useState("");
  const [questions, setQuestions] = useState([]);
  const [position, setPosition] = useState([]);
  const [selectedQnCode, setSelectedQnCode] = useState("Q1");
  const [finalOpen, setFinalOpen] = useState(false);
  const [evalData, setevalData] = useState([]);
  const [partsData, setpartsData] = useState([]);
  const [sumData, setsumData] = useState([]);
  const [ack, setAck] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [remarks, setRemarks] = useState("");
  const [guideModalOpen, setGuideModalOpen] = useState(false);
  const [targetTime, setTargetTime] = useState(null);
  const [val1Marks, setVal1Marks] = useState("");
  const [rejectOpen, setRejectOpen] = useState(false);
  const [arReason, setArReason] = useState("Script Re-scan request");
  const [arComment, setArComment] = useState("");
  const [qnModalOpen, setQnModalOpen] = useState(false);
  const [qnModal, setQnModal] = useState("");

  // Digital Valuation Annotations state
  const [annotations, setAnnotations] = useState([]);

  // Per-Page Zoom & Rotation Transform state { [pageIndex]: { zoom: 1.0, rotation: 0 } }
  const [pageTransforms, setPageTransforms] = useState({});

  // Currently Active Image Page Index
  const [activePage, setActivePage] = useState(0);

  // Dragging Annotation state
  const [draggingAnn, setDraggingAnn] = useState(null);
  const dragStartPos = useRef({
    mouseX: 0,
    mouseY: 0,
    hasMoved: false,
    imgRect: null,
    naturalWidth: 0,
    naturalHeight: 0,
  });

  // RAF reference for 60FPS ultra-smooth drag updates
  const rafRef = useRef(null);

  // Context Menu state
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    relX: 0,
    relY: 0,
    pixelX: 0,
    pixelY: 0,
    naturalWidth: 0,
    naturalHeight: 0,
    pageIndex: null,
    imageIdentifier: "",
    targetAnnotationId: null,
  });

  // Input Modal state for Add Marks and Adding Remarks
  const [inputModal, setInputModal] = useState({
    visible: false,
    type: "", // 'marks' or 'remark'
    title: "",
    placeholder: "",
    value: "",
    relX: 0,
    relY: 0,
    pixelX: 0,
    pixelY: 0,
    naturalWidth: 0,
    naturalHeight: 0,
    pageIndex: null,
    imageIdentifier: "",
  });

  // Go Back Navigation Handler
  const handleGoBack = useCallback(() => {
    if (props.history && props.history.goBack) {
      props.history.goBack();
    } else {
      window.history.back();
    }
  }, [props.history]);

  // Zoom In for specific page
  const handlePageZoomIn = useCallback((index) => {
    setPageTransforms((prev) => {
      const curr = prev[index] || { zoom: 1.0, rotation: 0 };
      const nextZoom = Math.min(
        3.0,
        Math.round((curr.zoom + 0.15) * 100) / 100,
      );
      return { ...prev, [index]: { ...curr, zoom: nextZoom } };
    });
  }, []);

  // Zoom Out for specific page
  const handlePageZoomOut = useCallback((index) => {
    setPageTransforms((prev) => {
      const curr = prev[index] || { zoom: 1.0, rotation: 0 };
      const nextZoom = Math.max(
        0.5,
        Math.round((curr.zoom - 0.15) * 100) / 100,
      );
      return { ...prev, [index]: { ...curr, zoom: nextZoom } };
    });
  }, []);

  useEffect(() => {
    if (!targetTime) return;
    const updateTimer = () => {
      const remaining = Math.max(
        0,
        Math.ceil((targetTime - Date.now()) / 1000),
      );
      setTimeLeft(remaining);
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [targetTime]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  // Rotate Right 90 deg for specific page
  const handlePageRotateRight = useCallback((index) => {
    setPageTransforms((prev) => {
      const curr = prev[index] || { zoom: 1.0, rotation: 0 };
      const nextRot = (curr.rotation + 90) % 360;
      return { ...prev, [index]: { ...curr, rotation: nextRot } };
    });
  }, []);

  // Rotate Left 90 deg for specific page
  const handlePageRotateLeft = useCallback((index) => {
    setPageTransforms((prev) => {
      const curr = prev[index] || { zoom: 1.0, rotation: 0 };
      const nextRot = (curr.rotation - 90 + 360) % 360;
      return { ...prev, [index]: { ...curr, rotation: nextRot } };
    });
  }, []);

  // Reset Zoom & Rotation for specific page
  const handlePageResetTransform = useCallback((index) => {
    setPageTransforms((prev) => ({
      ...prev,
      [index]: { zoom: 1.0, rotation: 0 },
    }));
  }, []);

  // High performance RAF MouseMove & TouchMove listener for Butter-Smooth Dragging
  useEffect(() => {
    if (!draggingAnn) return;

    const handleMouseMove = (e) => {
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;

      if (rafRef.current) cancelAnimationFrame(rafRef.current);

      rafRef.current = requestAnimationFrame(() => {
        const {
          mouseX,
          mouseY,
          imgRect,
          naturalWidth,
          naturalHeight,
        } = dragStartPos.current;
        const dx = Math.abs(clientX - mouseX);
        const dy = Math.abs(clientY - mouseY);

        if (dx > 3 || dy > 3) {
          dragStartPos.current.hasMoved = true;
        }

        if (dragStartPos.current.hasMoved && imgRect) {
          const offsetX = clientX - imgRect.left;
          const offsetY = clientY - imgRect.top;

          let relX = Math.max(
            0.5,
            Math.min(99.5, (offsetX / imgRect.width) * 100),
          );
          let relY = Math.max(
            0.5,
            Math.min(99.5, (offsetY / imgRect.height) * 100),
          );

          const pixelX = Math.round((relX / 100) * naturalWidth);
          const pixelY = Math.round((relY / 100) * naturalHeight);

          setAnnotations((prev) => {
            const updated = prev.map((a) =>
              a.id === draggingAnn.id
                ? {
                    ...a,
                    x: relX,
                    y: relY,
                    pixelX,
                    pixelY,
                    naturalWidth,
                    naturalHeight,
                  }
                : a,
            );
            setPosition(updated);
            return updated;
          });
        }
      });
    };

    const handleMouseUp = () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      setDraggingAnn(null);
    };

    window.addEventListener("mousemove", handleMouseMove, { passive: true });
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("touchmove", handleMouseMove, { passive: true });
    window.addEventListener("touchend", handleMouseUp);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleMouseMove);
      window.removeEventListener("touchend", handleMouseUp);
    };
  }, [draggingAnn]);

  // Hide context menu on global click
  useEffect(() => {
    const handleGlobalClick = () => {
      if (contextMenu.visible) {
        setContextMenu((prev) => ({ ...prev, visible: false }));
      }
    };
    window.addEventListener("click", handleGlobalClick);
    return () => window.removeEventListener("click", handleGlobalClick);
  }, [contextMenu.visible]);

  useEffect(() => {
    getEvaluationImages();
    getEvalPartsState();
  }, []);

  const getEvalPartsState = async () => {
    try {
      if (setLoader) setLoader(true);
      const res = await tdvs.get(
        "/app.php?a=getevalpartsstate&univcode=" +
          (sessionStorage.getItem("univcode") || "") +
          `&fteachcode=${fteachcode}&qpcode=${qpcode}&regcode=${regcode}&valno=${valno}`,
      );
      if (setLoader) setLoader(false);

      if (res && res.data && res.data.error_code === 0 && res.data.data) {
        setParts(res.data.data.parts || []);
        if (res.data.data.path && res.data.data.path.length > 0) {
          setOmrMarks(res.data.data.path[0].fomrmarks || "");
          setVal1Marks(res.data.data.path[0].val1marks);
        }
        if (
          Array.isArray(res.data.data.question) &&
          res.data.data.question.length > 0
        ) {
          setQuestions(res.data.data.question);
          const firstValidQn =
            res.data.data.question.find((q) => q.fsubqn !== "T") ||
            res.data.data.question[0];
          setSelectedQnCode(getQnCode(firstValidQn));
        }
      } else {
        const msg =
          (res && res.data && res.data.data && res.data.data.msg) ||
          "Error loading evaluation parts";
        if (dispatch_err) {
          dispatch_err({
            type: "OPEN_MSG_BOX",
            payload: {
              header: "Message",
              message: msg,
            },
          });
        }
      }
    } catch (e) {
      if (setLoader) setLoader(false);
      console.log("Error loading evaluation parts:", e);
    }
  };

  const finalsubmitEvalaution = async () => {
    await axios
      .post(
        NewApi +
          "a=finalEvalMarks&univcode=" +
          sessionStorage.getItem("univcode") +
          "&qpcode=" +
          qpcode +
          "&dummyno=" +
          regcode +
          "&valno=" +
          valno +
          "&fteachcode=" +
          fteachcode,
      )
      .then((res) => {
        console.log(res);
        if (res.data.error_code === 0) {
          history.push("/dashboard");
        } else {
          dispatch_err({
            type: "OPEN_MSG_BOX",
            payload: {
              header: "Error",
              message: res.data.data.msg,
            },
          });
          setLoader(false);
          return;
        }
      })
      .catch((err) => {
        dispatch_err({
          type: "OPEN_MSG_BOX",
          payload: {
            header: "Error",
            message: "Error while saving marks data ",
          },
        });
        setLoader(false);
        return;
      });
  };
  let row = evalData[0];
  let sum = sumData;

  const getEvaluationImages = async () => {
    try {
      if (setLoader) setLoader(true);
      const res = await tdvs.get(
        "/app.php?a=getevalimage&univcode=" +
          (sessionStorage.getItem("univcode") || "") +
          `&fteachcode=${fteachcode}&qpcode=${qpcode}&regcode=${regcode}&valno=${valno}`,
      );
      if (setLoader) setLoader(false);

      if (res && res.data && res.data.error_code === 0 && res.data.data) {
        let parsedPos = [];
        if (res.data.data.pos) {
          try {
            parsedPos =
              typeof res.data.data.pos === "string"
                ? JSON.parse(res.data.data.pos)
                : res.data.data.pos;
          } catch (e) {
            console.log("Error parsing position data:", e);
          }
        }
        if (!Array.isArray(parsedPos)) parsedPos = [];

        setFileNames(
          Array.isArray(res.data.data.filenames) ? res.data.data.filenames : [],
        );
        setPosition(parsedPos);
        setAnnotations(parsedPos);
        setFilepath(res.data.data.ffilepath || "");
        setQpSchemePath(res.data.data.qpschmepath || {});
        if (res.data.data.istimer === "T") {
          const durationSec = res.data.data.timer
            ? parseInt(res.data.data.timer, 10)
            : 180;
          if (res.data.data.timestamp) {
            const start = new Date(
              res.data.data.timestamp.replace(/-/g, "/"),
            ).getTime();
            setTargetTime(start + durationSec * 1000);
          } else {
            setTargetTime(Date.now() + durationSec * 1000);
          }
        } else {
          setTargetTime(null);
          setTimeLeft(0);
        }
      } else {
        const msg =
          res && res.data && res.data.data && res.data.data.msg
            ? res.data.data.msg
            : "Error loading booklet images";
        if (dispatch_err) {
          dispatch_err({
            type: "OPEN_MSG_BOX",
            payload: {
              header: "Message",
              message: msg,
            },
          });
        }
      }
    } catch (err) {
      if (setLoader) setLoader(false);
      console.log("Error loading evaluation images:", err);
    }
  };

  const handleOpenQp = () => {
    let qnFilter = questions.filter((q) => q.fquestion != "");
    if (qnFilter.length > 0) {
      setQnModal("questions");
    } else {
      if (qpSchemepath && qpSchemepath.fqppath) {
        window.open(
          `https://answer-booklets.s3.ap-south-1.amazonaws.com/${qpSchemepath.fqppath}`,
          "_blank",
        );
      } else {
        if (dispatch_err) {
          dispatch_err({
            type: "OPEN_MSG_BOX",
            payload: {
              header: "Message",
              message: "Question Paper path not found",
            },
          });
        }
      }
    }
  };

  const handleOpenScheme = () => {
    let keyansFilter = questions.filter((q) => q.fkeyans != "");
    if (keyansFilter.length > 0) {
      setQnModal("answers");
    } else {
      if (qpSchemepath && qpSchemepath.fschempath) {
        window.open(
          `https://answer-booklets.s3.ap-south-1.amazonaws.com/${qpSchemepath.fschempath}`,
          "_blank",
        );
      } else {
        if (dispatch_err) {
          dispatch_err({
            type: "OPEN_MSG_BOX",
            payload: {
              header: "Message",
              message: "Answer Scheme path not found",
            },
          });
        }
      }
    }
  };

  // Save Final Evaluation Handler
  const handleSave = async (saveType) => {
    if (!valuationProgressStats.isFullyComplete && saveType === "save") {
      if (dispatch_err) {
        dispatch_err({
          type: "OPEN_MSG_BOX",
          payload: {
            header: "Evaluation Incomplete",
            message: `Evaluation cannot be saved yet. Valuation must be 100% completed. Currently: ${valuationProgressStats.assessedQns}/${valuationProgressStats.totalQns} questions evaluated and ${valuationProgressStats.annotatedPages}/${valuationProgressStats.totalPages} booklet pages annotated/struck out (${valuationProgressStats.overallProgress}% overall progress).`,
          },
        });
      }
      return;
    }

    if (saveType == "save" && timeLeft > 0) {
      dispatch_err({
        type: "OPEN_MSG_BOX",
        payload: {
          header: "Message",
          message: `Please wait ${formatTime(timeLeft)} before saving.`,
        },
      });
      return;
    }

    try {
      if (setLoader) setLoader(true);
      const postData = {
        qpcode,
        regcode,
        valno,
        fteachcode,
        questions,
        annotations,
        position,
        fimgposjson: JSON.stringify(position),
      };
      console.log(postData, "postDatapostData");

      const res = await axios.post(
        NewApi +
          `a=saveEvaluationMarks&univcode=${sessionStorage.getItem(
            "univcode",
          ) ||
            ""}&fteachcode=${fteachcode}&qpcode=${qpcode}&dummyno=${regcode}&valno=${valno}&valtype=rightClickVal`,
        postData,
      );
      if (setLoader) setLoader(false);

      const msg =
        (res && res.data && res.data.data && res.data.data.msg) ||
        "Evaluation saved successfully!";

      if (dispatch_err && saveType === "draft") {
        dispatch_err({
          type: "OPEN_MSG_BOX",
          payload: {
            header: "Saved Successfully",
            message: msg,
          },
        });
      } else {
        getEvalMarksStatus();
      }
    } catch (err) {
      if (setLoader) setLoader(false);
      console.log("Error saving evaluation:", err);
    }
  };

  const getEvalMarksStatus = async () => {
    await axios
      .get(
        NewApi +
          "a=getEvalMarksStatus&univcode=" +
          sessionStorage.getItem("univcode") +
          "&qpcode=" +
          qpcode +
          "&dummyno=" +
          regcode +
          "&valno=" +
          valno,
      )
      .then((res) => {
        console.log(res);
        if (res.data.error_code === 0) {
          setevalData(res.data.data.sdata);
          setpartsData(res.data.data.pdata);
          setsumData(res.data.data.sum);
          setFinalOpen(true);
        } else {
          dispatch_err({
            type: "OPEN_MSG_BOX",
            payload: {
              header: "Message",
              message: res.data.data.msg,
            },
          });
          setLoader(false);
          return;
        }
      })
      .catch((err) => {
        dispatch_err({
          type: "OPEN_MSG_BOX",
          payload: {
            header: "Error",
            message: "Error while getting marks data ",
          },
        });
        setLoader(false);
        return;
      });
  };

  // Save Draft Handler
  const handleSaveDraft = async () => {
    try {
      if (setLoader) setLoader(true);
      const postData = {
        qpcode,
        regcode,
        valno,
        fteachcode,
        questions,
        annotations,
        position,
        fimgposjson: JSON.stringify(position),
      };
      const res = await tdvs.post(
        `/app.php?a=saveEvaluationDraft&univcode=${sessionStorage.getItem(
          "univcode",
        ) ||
          ""}&fteachcode=${fteachcode}&qpcode=${qpcode}&regcode=${regcode}&valno=${valno}`,
        postData,
      );
      if (setLoader) setLoader(false);

      const msg =
        (res && res.data && res.data.data && res.data.data.msg) ||
        "Draft evaluation saved successfully!";
      if (dispatch_err) {
        dispatch_err({
          type: "OPEN_MSG_BOX",
          payload: {
            header: "Draft Saved",
            message: msg,
          },
        });
      }
    } catch (err) {
      if (setLoader) setLoader(false);
      console.log("Error saving draft:", err);
    }
  };

  const saveEvalReject = async () => {
    setLoader(true);
    await axios
      .post(
        NewApi +
          "a=saveEvalReject&univcode=" +
          sessionStorage.getItem("univcode") +
          "&rejReason=" +
          arReason +
          "&rejComment=" +
          arComment +
          "&qpcode=" +
          qpcode +
          "&dummyno=" +
          regcode +
          "&valno=" +
          valno,
      )
      .then((res) => {
        console.log(res);
        if (res.data.error_code === 0) {
          setLoader(false);
          history.push("/dashboard");
        } else {
          dispatch_err({
            type: "OPEN_MSG_BOX",
            payload: {
              header: "Message",
              message: res.data.data.msg,
            },
          });
          setLoader(false);
          return;
        }
      })
      .catch((err) => {
        dispatch_err({
          type: "OPEN_MSG_BOX",
          payload: {
            header: "Error",
            message: "Error while rejecting scripts",
          },
        });
        setLoader(false);
        return;
      });
  };

  // Scroll smooth to clicked image page
  const scrollToImage = useCallback((index) => {
    setActivePage(index);
    const element = document.getElementById(`page-container-${index}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  // Start dragging annotation relative to exact img element
  const handleAnnotationMouseDown = (e, ann) => {
    const isTouch = e.type === "touchstart";
    if (!isTouch && e.button !== 0) return;

    e.stopPropagation();
    const containerElement = e.currentTarget.closest(
      '[data-image-container="true"]',
    );
    if (!containerElement) return;

    const imgElement =
      containerElement.querySelector("img") || containerElement;
    const imgRect = imgElement.getBoundingClientRect();

    const clientX = isTouch ? e.touches[0].clientX : e.clientX;
    const clientY = isTouch ? e.touches[0].clientY : e.clientY;

    dragStartPos.current = {
      mouseX: clientX,
      mouseY: clientY,
      hasMoved: false,
      imgRect,
      naturalWidth: imgElement.naturalWidth || imgRect.width,
      naturalHeight: imgElement.naturalHeight || imgRect.height,
    };

    setDraggingAnn({
      id: ann.id,
      containerElement,
    });
  };

  const handleAnnotationClick = (e, id) => {
    e.stopPropagation();
    if (dragStartPos.current.hasMoved) {
      dragStartPos.current.hasMoved = false;
      return;
    }
    removeAnnotation(id);
  };

  // Handle right-click directly on the exact image element
  const handleContextMenu = (e, pageIndex, imageIdentifier) => {
    e.preventDefault();
    setActivePage(pageIndex);

    const container = e.currentTarget;
    const imgElement = container.querySelector("img") || container;
    const imgRect = imgElement.getBoundingClientRect();

    const offsetX = e.clientX - imgRect.left;
    const offsetY = e.clientY - imgRect.top;

    const relX = Math.max(0, Math.min(100, (offsetX / imgRect.width) * 100));
    const relY = Math.max(0, Math.min(100, (offsetY / imgRect.height) * 100));

    const naturalWidth = imgElement.naturalWidth || Math.round(imgRect.width);
    const naturalHeight =
      imgElement.naturalHeight || Math.round(imgRect.height);
    const pixelX = Math.round((relX / 100) * naturalWidth);
    const pixelY = Math.round((relY / 100) * naturalHeight);

    const targetAnn = annotations.find(
      (a) =>
        (a.imageIdentifier === imageIdentifier || a.pageIndex === pageIndex) &&
        Math.abs(a.x - relX) < 6 &&
        Math.abs(a.y - relY) < 6,
    );

    setContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      relX,
      relY,
      pixelX,
      pixelY,
      naturalWidth,
      naturalHeight,
      pageIndex,
      imageIdentifier,
      targetAnnotationId: targetAnn ? targetAnn.id : null,
    });
  };

  // Add Annotation handler
  const handleAddAnnotation = (type) => {
    const {
      pageIndex,
      imageIdentifier,
      relX,
      relY,
      pixelX,
      pixelY,
      naturalWidth,
      naturalHeight,
    } = contextMenu;
    setContextMenu({ ...contextMenu, visible: false });

    if (type === "strike_page") {
      const existingPageStrike = annotations.find(
        (a) =>
          (a.imageIdentifier === imageIdentifier ||
            a.pageIndex === pageIndex) &&
          a.type === "strike_page",
      );
      if (existingPageStrike) {
        removeAnnotation(existingPageStrike.id);
      } else {
        const newAnn = {
          id: Date.now() + Math.random(),
          imageIdentifier,
          pageIndex,
          type: "strike_page",
          x: 0,
          y: 0,
          pixelX: 0,
          pixelY: 0,
          naturalWidth,
          naturalHeight,
        };
        setAnnotations((prev) => [...prev, newAnn]);
        setPosition((prev) => [...(Array.isArray(prev) ? prev : []), newAnn]);
      }
      return;
    }

    if (type === "marks") {
      const currentQn = questions.find((q) => isQnMatch(q, selectedQnCode));
      const initialMark =
        currentQn && currentQn.fmarks !== "-1" && currentQn.fmarks !== "-1.0"
          ? currentQn.fmarks
          : "";
      setInputModal({
        visible: true,
        type: "marks",
        title: `Add Marks (${selectedQnCode})`,
        placeholder: "Select marks",
        value: initialMark,
        relX,
        relY,
        pixelX,
        pixelY,
        naturalWidth,
        naturalHeight,
        pageIndex,
        imageIdentifier,
      });
      return;
    }

    if (type === "remark") {
      setInputModal({
        visible: true,
        type: "remark",
        title: "Adding Remarks",
        placeholder: "Enter remark text...",
        value: "",
        relX,
        relY,
        pixelX,
        pixelY,
        naturalWidth,
        naturalHeight,
        pageIndex,
        imageIdentifier,
      });
      return;
    }

    const newAnn = {
      id: Date.now() + Math.random(),
      imageIdentifier,
      pageIndex,
      type,
      x: relX,
      y: relY,
      pixelX,
      pixelY,
      naturalWidth,
      naturalHeight,
      qnCode: selectedQnCode,
    };
    setAnnotations((prev) => [...prev, newAnn]);
    setPosition((prev) => [...(Array.isArray(prev) ? prev : []), newAnn]);
  };

  // Calculate total marks annotations sum for a specific question
  const getQuestionAnnotationsSum = (targetQnCode, annList = annotations) => {
    return (annList || []).reduce((sum, ann) => {
      if (
        ann.type === "marks" &&
        isQnMatch({ fqnno: ann.qnCode, fqncode: ann.qnCode }, targetQnCode)
      ) {
        const val = parseFloat(ann.value);
        return sum + (isNaN(val) ? 0 : val);
      }
      return sum;
    }, 0);
  };

  // Submit Modal Input for Marks or Remarks
  const handleModalSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!inputModal.value.trim()) return;

    const val = inputModal.value.trim();
    const numVal = parseFloat(val);

    // Max Marks validation for question annotations
    if (
      inputModal.type === "marks" &&
      !isNaN(numVal) &&
      val.toUpperCase() !== "N"
    ) {
      const currentSum = getQuestionAnnotationsSum(selectedQnCode, annotations);
      const newTotalForQn = currentSum + numVal;
      const maxMarksForQn = parseFloat(
        selectedQuestion ? selectedQuestion.fmaxmarks : 10,
      );

      if (newTotalForQn > maxMarksForQn) {
        if (dispatch_err) {
          dispatch_err({
            type: "OPEN_MSG_BOX",
            payload: {
              header: "Maximum Marks Exceeded",
              message: `Cannot add ${numVal} marks for Question ${selectedQnCode}. Total marks would be ${newTotalForQn} M, which exceeds the maximum allowed limit of ${maxMarksForQn} M (Current total on booklet pages: ${currentSum} M).`,
            },
          });
        }
        setInputModal({ ...inputModal, visible: false, value: "" });
        return;
      }
    }

    const targetX =
      inputModal.type === "marks"
        ? Math.min(95, inputModal.relX + 11.5)
        : inputModal.relX;
    const targetPixelX =
      inputModal.type === "marks"
        ? Math.round((targetX / 100) * (inputModal.naturalWidth || 1000))
        : inputModal.pixelX;

    const newAnn = {
      id: Date.now() + Math.random(),
      imageIdentifier: inputModal.imageIdentifier,
      pageIndex: inputModal.pageIndex,
      type: inputModal.type,
      x: targetX,
      y: inputModal.relY,
      pixelX: targetPixelX,
      pixelY: inputModal.pixelY,
      naturalWidth: inputModal.naturalWidth,
      naturalHeight: inputModal.naturalHeight,
      value: val,
      qnCode: selectedQnCode,
    };

    const newAnns = [newAnn];

    // Automatically add annotation next to marks:
    // If marks > 0: auto-add tick (✓)
    // If marks === 0 (and not 'N'): auto-add strikeout (✗)
    if (
      inputModal.type === "marks" &&
      !isNaN(numVal) &&
      val.toUpperCase() !== "N"
    ) {
      const autoAnnType = numVal > 0 ? "tick" : "strikeout";

      const autoAnn = {
        id: Date.now() + Math.random() + 1,
        imageIdentifier: inputModal.imageIdentifier,
        pageIndex: inputModal.pageIndex,
        type: autoAnnType,
        x: inputModal.relX,
        y: inputModal.relY,
        pixelX: inputModal.pixelX,
        pixelY: inputModal.pixelY,
        naturalWidth: inputModal.naturalWidth,
        naturalHeight: inputModal.naturalHeight,
        qnCode: selectedQnCode,
        fromMarks: true,
      };
      newAnns.push(autoAnn);
    }

    const updatedAnnotations = [...annotations, ...newAnns];
    setAnnotations(updatedAnnotations);
    setPosition(updatedAnnotations);

    if (inputModal.type === "marks") {
      if (!isNaN(numVal) && val.toUpperCase() !== "N") {
        const totalQnSum = getQuestionAnnotationsSum(
          selectedQnCode,
          updatedAnnotations,
        );
        updateQuestionMarks(selectedQnCode, totalQnSum.toString());
      } else {
        updateQuestionMarks(selectedQnCode, val);
      }
    }

    if (inputModal.type === "remark") {
      updateQuestionRemarks(selectedQnCode, val);
    }

    setInputModal({ ...inputModal, visible: false, value: "" });
  };

  // Update Question Marks in state
  const changeMarksHandler = useCallback((val, index) => {
    setQuestions((prev) => {
      const arr = [...prev];
      if (arr[index]) {
        arr[index] = {
          ...arr[index],
          fmarks: val === "" ? "-1" : String(val).toUpperCase(),
        };
      }
      return arr;
    });
  }, []);

  const changeRemarksHandler = useCallback((e, index) => {
    const val = e.target.value;
    setQuestions((prev) => {
      const arr = [...prev];
      if (arr[index]) {
        arr[index] = { ...arr[index], fremarks: val };
      }
      return arr;
    });
  }, []);

  // Flexible Question Code Matching Helpers
  const getQnCode = (q) => {
    if (!q) return "";
    return String(q.fqnno || q.fqncode || "").trim();
  };

  const isQnMatch = (q, targetCode) => {
    if (!q || !targetCode) return false;
    const t = String(targetCode)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");
    const c1 = String(q.fqnno || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");
    const c2 = String(q.fqncode || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");
    return t === c1 || t === c2;
  };

  const updateQuestionMarks = useCallback((qnCode, marksVal) => {
    setQuestions((prev) =>
      prev.map((q) =>
        isQnMatch(q, qnCode)
          ? { ...q, fmarks: String(marksVal).toUpperCase() }
          : q,
      ),
    );
  }, []);

  const updateQuestionRemarks = useCallback((qnCode, remarkVal) => {
    setQuestions((prev) =>
      prev.map((q) =>
        isQnMatch(q, qnCode) ? { ...q, fremarks: remarkVal } : q,
      ),
    );
  }, []);

  // Handler to mark all unassigned / left-out questions as 'N' (preserves any question with existing marks)
  const handleMarkNaForAll = () => {
    let count = 0;
    setQuestions((prev) =>
      prev.map((q) => {
        const m = String(q.fmarks || "").trim();
        // Question has existing valid marks if fmarks is not empty, -1, -1.0, -2, -2.0
        const hasExistingMarks =
          m !== "" && m !== "-1" && m !== "-1.0" && m !== "-2" && m !== "-2.0";

        // If question already has marks awarded, DO NOT change it to 'N'
        if (hasExistingMarks) {
          return q;
        }

        // Only mark 'N' for left-out/unanswered questions
        count++;
        return { ...q, fmarks: "N" };
      }),
    );

    if (count > 0) {
      if (dispatch_err) {
        dispatch_err({
          type: "OPEN_MSG_BOX",
          payload: {
            header: "Marked NA for Unanswered",
            message: `Successfully marked 'N' for ${count} left-out question(s). Existing marks were preserved.`,
          },
        });
      }
    } else {
      if (dispatch_err) {
        dispatch_err({
          type: "OPEN_MSG_BOX",
          payload: {
            header: "Notice",
            message: "All questions already have marks or have been evaluated.",
          },
        });
      }
    }
  };

  // Complete Valuation Handler: strike out entire un-annotated pages
  const handleCompleteValuation = () => {
    const newStrikeAnns = [];
    let struckCount = 0;

    fileList.forEach((filename, i) => {
      // Check if this page has ANY annotations currently
      const hasAnyAnn = annotations.some(
        (a) => a.imageIdentifier === filename || a.pageIndex === i,
      );

      if (!hasAnyAnn) {
        struckCount++;
        newStrikeAnns.push({
          id: Date.now() + Math.random() + i,
          imageIdentifier: filename,
          pageIndex: i,
          type: "strike_page",
          x: 0,
          y: 0,
          pixelX: 0,
          pixelY: 0,
          naturalWidth: 1000,
          naturalHeight: 1400,
        });
      }
    });

    if (struckCount > 0) {
      const updatedAnns = [...annotations, ...newStrikeAnns];
      setAnnotations(updatedAnns);
      setPosition(updatedAnns);

      if (dispatch_err) {
        dispatch_err({
          type: "OPEN_MSG_BOX",
          payload: {
            header: "Valuation Completed",
            message: `Applied full-page strikeout to ${struckCount} un-annotated page(s).`,
          },
        });
      }
    } else {
      if (dispatch_err) {
        dispatch_err({
          type: "OPEN_MSG_BOX",
          payload: {
            header: "Notice",
            message: "All pages already have annotations or strikeouts.",
          },
        });
      }
    }
  };

  // Remove Annotation
  const handleRemoveAnnotation = () => {
    const { pageIndex, imageIdentifier, targetAnnotationId } = contextMenu;
    setContextMenu({ ...contextMenu, visible: false });

    if (targetAnnotationId) {
      removeAnnotation(targetAnnotationId);
    } else {
      const pageAnns = annotations.filter(
        (a) =>
          a.imageIdentifier === imageIdentifier || a.pageIndex === pageIndex,
      );
      if (pageAnns.length > 0) {
        const lastAnn = pageAnns[pageAnns.length - 1];
        removeAnnotation(lastAnn.id);
      }
    }
  };

  const removeAnnotation = (id) => {
    const targetAnn = annotations.find((a) => a.id === id);
    const updatedAnns = annotations.filter((a) => a.id !== id);
    setAnnotations(updatedAnns);
    setPosition(updatedAnns);

    if (targetAnn && targetAnn.type === "marks" && targetAnn.qnCode) {
      const remainingSum = getQuestionAnnotationsSum(
        targetAnn.qnCode,
        updatedAnns,
      );
      const remainingMarksAnns = updatedAnns.filter(
        (a) =>
          a.type === "marks" &&
          isQnMatch({ fqnno: a.qnCode, fqncode: a.qnCode }, targetAnn.qnCode),
      );

      if (remainingMarksAnns.length > 0) {
        updateQuestionMarks(targetAnn.qnCode, remainingSum.toString());
      } else {
        updateQuestionMarks(targetAnn.qnCode, "-1");
      }
    }

    if (targetAnn && targetAnn.type === "remark" && targetAnn.qnCode) {
      const remainingRemarkAnns = updatedAnns.filter(
        (a) =>
          a.type === "remark" &&
          isQnMatch({ fqnno: a.qnCode, fqncode: a.qnCode }, targetAnn.qnCode),
      );
      if (remainingRemarkAnns.length > 0) {
        updateQuestionRemarks(
          targetAnn.qnCode,
          remainingRemarkAnns[remainingRemarkAnns.length - 1].value || "",
        );
      } else {
        updateQuestionRemarks(targetAnn.qnCode, "");
      }
    }
  };

  // Position for context menu bounds
  const getContextMenuPosition = () => {
    const menuWidth = 240;
    const menuHeight = 290;
    const posX =
      contextMenu.x + menuWidth > window.innerWidth
        ? contextMenu.x - menuWidth
        : contextMenu.x;
    const posY =
      contextMenu.y + menuHeight > window.innerHeight
        ? contextMenu.y - menuHeight
        : contextMenu.y;
    return { left: posX, top: posY };
  };

  const fileList = useMemo(() => (Array.isArray(filename) ? filename : []), [
    filename,
  ]);
  const questionList = useMemo(
    () => (Array.isArray(questions) ? questions : []),
    [questions],
  );

  // Currently selected question object (excluding fsubqn === 'T')
  const selectedQuestion = useMemo(() => {
    return (
      questionList.find(
        (q) => isQnMatch(q, selectedQnCode) && q.fsubqn !== "T",
      ) ||
      questionList.find((q) => q.fsubqn !== "T") ||
      questionList[0]
    );
  }, [questionList, selectedQnCode]);

  // Options array for the selected question (0, 0.5 to maxmarks + N)
  const selectedQuestionOptions = useMemo(() => {
    if (!selectedQuestion) return [];
    const maxVal = parseFloat(selectedQuestion.fmaxmarks || 10);
    const opts = Array.from({ length: Math.round(maxVal * 2) }, (_, k) => ({
      label: ((k + 1) * 0.5).toString(),
      value: ((k + 1) * 0.5).toString(),
    }));
    return [
      { label: "0", value: "0" },
      ...opts,
      { label: "N (Not Answered)", value: "N" },
    ];
  }, [selectedQuestion]);

  // Calculate total marks across all questions
  const totalMarksAwarded = useMemo(
    () =>
      questionList.reduce((sum, q) => {
        const m = q.fsubqn != "T" ? q.fmarks : undefined;
        const num =
          m === "-1" ||
          m === "-1.0" ||
          m === "-2" ||
          m === "-2.0" ||
          m === "N" ||
          m === "NA" ||
          m === "" ||
          m === undefined ||
          m === null
            ? 0
            : parseFloat(m);
        return sum + (isNaN(num) ? 0 : num);
      }, 0),
    [questionList],
  );

  // Valuation Progress Calculation (Questions Assessed + Pages Annotated)
  const valuationProgressStats = useMemo(() => {
    const evaluableQuestions = questionList.filter((q) => q.fsubqn !== "T");
    const totalQns = evaluableQuestions.length;

    const assessedQns = evaluableQuestions.filter((q) => {
      const m = String(q.fmarks || "").trim();
      return (
        m !== "" && m !== "-1" && m !== "-1.0" && m !== "-2" && m !== "-2.0"
      );
    }).length;

    const qnPercentage = totalQns > 0 ? (assessedQns / totalQns) * 100 : 0;

    const totalPages = fileList.length;
    const annotatedPages = fileList.filter((filename, i) =>
      annotations.some(
        (a) => a.imageIdentifier === filename || a.pageIndex === i,
      ),
    ).length;

    const pagePercentage =
      totalPages > 0 ? (annotatedPages / totalPages) * 100 : 0;

    const isFullyComplete =
      assessedQns === totalQns && annotatedPages === totalPages && totalQns > 0;

    const overallProgress = isFullyComplete
      ? 100
      : Math.min(99, Math.round((qnPercentage + pagePercentage) / 2));

    return {
      assessedQns,
      totalQns,
      annotatedPages,
      totalPages,
      qnPercentage,
      pagePercentage,
      overallProgress,
      isFullyComplete,
    };
  }, [questionList, fileList, annotations]);

  // Render single Question Table Row helper
  const renderQnTableRow = (que, index) => {
    const qnCode = getQnCode(que);
    const isSelected = isQnMatch(que, selectedQnCode);
    const hasMarks =
      que.fmarks !== "-1" &&
      que.fmarks !== "-1.0" &&
      que.fmarks !== "" &&
      que.fmarks !== undefined;
    const maxMarks = que.fmaxmarks ? `${que.fmaxmarks} M` : "-";

    return (
      <tr
        key={qnCode || index}
        onClick={() => setSelectedQnCode(qnCode)}
        style={{
          cursor: "pointer",
          background: isSelected ? "#eff6ff" : "#ffffff",
          borderLeft: isSelected
            ? "4px solid #2563eb"
            : "4px solid transparent",
          transition: "background 0.15s ease",
        }}
      >
        <td
          style={{
            padding: "8px 12px",
            fontSize: "13px",
            fontWeight: isSelected ? "800" : "700",
            color: isSelected ? "#1d4ed8" : "#1e293b",
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          Question {qnCode}
        </td>
        <td
          style={{
            padding: "8px 12px",
            fontSize: "12px",
            fontWeight: "600",
            color: "#64748b",
            textAlign: "center",
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          {maxMarks}
        </td>
        <td
          style={{
            padding: "8px 12px",
            textAlign: "right",
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          {hasMarks ? (
            <span
              style={{
                display: "inline-block",
                padding: "3px 10px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: "800",
                background:
                  que.fmarks.toUpperCase() === "N" ? "#f1f5f9" : "#dcfce7",
                color: que.fmarks.toUpperCase() === "N" ? "#64748b" : "#15803d",
                border:
                  que.fmarks.toUpperCase() === "N"
                    ? "1px solid #cbd5e1"
                    : "1px solid #86efac",
              }}
            >
              {que.fmarks}
            </span>
          ) : (
            <span
              style={{
                fontSize: "12px",
                color: "#94a3b8",
                fontWeight: "500",
              }}
            >
              -
            </span>
          )}
        </td>
      </tr>
    );
  };

  return (
    <div style={styles.container}>
      {/* 3-Column Full-Screen Layout: Column 1 (Left 67%: Images) | Column 2 (Middle 8%: Thumbnails) | Column 3 (Right 25%: Styled Table Card) */}
      <div style={styles.mainLayout}>
        {/* COLUMN 1 (67% Leftmost): Main Answer Booklet Images & Fast Drag Annotations */}
        <div style={styles.column1}>
          {fileList.length > 0 ? (
            fileList.map((el, i) => {
              const pageAnnotations = annotations.filter(
                (a) => a.imageIdentifier === el || a.pageIndex === i,
              );
              const transform = pageTransforms[i] || { zoom: 1.0, rotation: 0 };
              const { zoom = 1.0, rotation = 0 } = transform;

              return (
                <div
                  key={el || i}
                  id={`page-container-${i}`}
                  data-image-container="true"
                  data-image-id={el}
                  style={styles.pageContainer}
                >
                  {/* Floating Fast Controls Toolbar for Zoom In, Zoom Out, Rotate & Reset */}
                  <div
                    style={styles.floatingToolbar}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      onClick={() => handlePageZoomIn(i)}
                      style={styles.toolbarBtn}
                      title="Zoom In (+15%)"
                    >
                      🔍+
                    </button>
                    <button
                      onClick={() => handlePageZoomOut(i)}
                      style={styles.toolbarBtn}
                      title="Zoom Out (-15%)"
                    >
                      🔍-
                    </button>
                    <button
                      onClick={() => handlePageRotateLeft(i)}
                      style={styles.toolbarBtn}
                      title="Rotate Counter-Clockwise (90°)"
                    >
                      ⤾
                    </button>
                    <button
                      onClick={() => handlePageRotateRight(i)}
                      style={styles.toolbarBtn}
                      title="Rotate Clockwise (90°)"
                    >
                      ⤿
                    </button>
                    {(zoom !== 1 || rotation !== 0) && (
                      <button
                        onClick={() => handlePageResetTransform(i)}
                        style={styles.toolbarResetBtn}
                        title="Reset Zoom & Rotation"
                      >
                        ↺ Reset
                      </button>
                    )}
                    <span style={styles.toolbarBadge}>
                      {Math.round(zoom * 100)}%
                      {rotation !== 0 ? ` | ${rotation}°` : ""}
                    </span>
                  </div>

                  {/* Image Position & Transform Wrapper */}
                  <div
                    onContextMenu={(e) => handleContextMenu(e, i, el)}
                    style={{
                      position: "relative",
                      width: "100%",
                      transform: `scale(${zoom}) rotate(${rotation}deg)`,
                      transformOrigin: "center center",
                      transition: "transform 0.15s ease-out",
                    }}
                  >
                    <img
                      style={{
                        width: "100%",
                        display: "block",
                        userSelect: "none",
                      }}
                      src={
                        "https://answer-booklets.s3.ap-south-1.amazonaws.com/eval-img/" +
                        filepath +
                        el
                      }
                      alt={`Answer Booklet Page - ${el}`}
                    />

                    {/* Render Annotations positioned accurately on the image element */}
                    {pageAnnotations.map((ann) => {
                      const isBeingDragged =
                        draggingAnn && draggingAnn.id === ann.id;
                      const tooltipText = `Image: ${
                        ann.imageIdentifier
                      } | Pos: (${Math.round(ann.x)}%, ${Math.round(
                        ann.y,
                      )}%) [${ann.pixelX || 0}px, ${ann.pixelY ||
                        0}px] • Drag to move • Click to delete`;

                      if (ann.type === "tick") {
                        const rawQn =
                          ann.fromMarks && ann.qnCode
                            ? String(ann.qnCode).trim()
                            : "";
                        const qnDisplay = rawQn
                          ? rawQn.endsWith(")")
                            ? rawQn
                            : `${rawQn})`
                          : "";

                        return (
                          <div
                            key={ann.id}
                            onMouseDown={(e) =>
                              handleAnnotationMouseDown(e, ann)
                            }
                            onTouchStart={(e) =>
                              handleAnnotationMouseDown(e, ann)
                            }
                            onClick={(e) => handleAnnotationClick(e, ann.id)}
                            style={{
                              position: "absolute",
                              left: `${ann.x}%`,
                              top: `${ann.y}%`,
                              transform: isBeingDragged
                                ? "translate(0, -50%) scale(1.2)"
                                : "translate(0, -50%)",
                              color: "#16a34a",
                              fontWeight: "900",
                              userSelect: "none",
                              cursor: isBeingDragged ? "grabbing" : "grab",
                              filter: isBeingDragged
                                ? "drop-shadow(0px 4px 10px rgba(22,163,74,0.6))"
                                : "drop-shadow(0px 2px 5px rgba(0,0,0,0.35))",
                              zIndex: isBeingDragged ? 20 : 10,
                              transition: isBeingDragged
                                ? "none"
                                : "transform 0.1s ease",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              whiteSpace: "nowrap",
                              lineHeight: 1,
                            }}
                            title={tooltipText}
                          >
                            {qnDisplay && (
                              <span
                                style={{
                                  fontSize: "24px",
                                  fontWeight: "800",
                                  color: "#16a34a",
                                }}
                              >
                                {qnDisplay}
                              </span>
                            )}
                            <span
                              style={{ fontSize: "44px", fontWeight: "900" }}
                            >
                              ✓
                            </span>
                          </div>
                        );
                      }

                      if (ann.type === "strikeout") {
                        return (
                          <div
                            key={ann.id}
                            onMouseDown={(e) =>
                              handleAnnotationMouseDown(e, ann)
                            }
                            onTouchStart={(e) =>
                              handleAnnotationMouseDown(e, ann)
                            }
                            onClick={(e) => handleAnnotationClick(e, ann.id)}
                            style={{
                              position: "absolute",
                              left: `${ann.x}%`,
                              top: `${ann.y}%`,
                              transform: isBeingDragged
                                ? "translate(0, -50%) scale(1.2)"
                                : "translate(0, -50%)",
                              color: "#dc2626",
                              fontSize: "48px",
                              fontWeight: "900",
                              userSelect: "none",
                              cursor: isBeingDragged ? "grabbing" : "grab",
                              filter: isBeingDragged
                                ? "drop-shadow(0px 4px 10px rgba(220,38,38,0.6))"
                                : "drop-shadow(0px 2px 5px rgba(0,0,0,0.35))",
                              zIndex: isBeingDragged ? 20 : 10,
                              transition: isBeingDragged
                                ? "none"
                                : "transform 0.1s ease",
                            }}
                            title={tooltipText}
                          >
                            ✗
                          </div>
                        );
                      }

                      if (ann.type === "strike_page") {
                        return (
                          <div
                            key={ann.id}
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              pointerEvents: "none",
                              zIndex: 15,
                            }}
                          >
                            <svg style={{ width: "100%", height: "100%" }}>
                              <line
                                x1="0"
                                y1="0"
                                x2="100%"
                                y2="100%"
                                stroke="#dc2626"
                                strokeWidth="5"
                                strokeDasharray="8 4"
                                opacity="0.85"
                              />
                              <line
                                x1="100%"
                                y1="0"
                                x2="0"
                                y2="100%"
                                stroke="#dc2626"
                                strokeWidth="5"
                                strokeDasharray="8 4"
                                opacity="0.85"
                              />
                            </svg>
                            <div
                              onClick={() => removeAnnotation(ann.id)}
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform:
                                  "translate(-50%, -50%) rotate(-25deg)",
                                background: "rgba(220, 38, 38, 0.95)",
                                color: "#ffffff",
                                fontWeight: "bold",
                                fontSize: "22px",
                                padding: "10px 28px",
                                borderRadius: "8px",
                                letterSpacing: "2px",
                                boxShadow: "0 4px 15px rgba(220, 38, 38, 0.5)",
                                pointerEvents: "auto",
                                cursor: "pointer",
                                userSelect: "none",
                              }}
                              title={`Click to remove full page strike (Image: ${ann.imageIdentifier})`}
                            >
                              PAGE STRUCK OUT ✕
                            </div>
                          </div>
                        );
                      }

                      if (ann.type === "marks") {
                        return (
                          <div
                            key={ann.id}
                            onMouseDown={(e) =>
                              handleAnnotationMouseDown(e, ann)
                            }
                            onTouchStart={(e) =>
                              handleAnnotationMouseDown(e, ann)
                            }
                            onClick={(e) => handleAnnotationClick(e, ann.id)}
                            style={{
                              position: "absolute",
                              left: `${ann.x}%`,
                              top: `${ann.y}%`,
                              transform: isBeingDragged
                                ? "translate(0, -50%) scale(1.18)"
                                : "translate(0, -50%)",
                              background: "#1890ff",
                              color: "#ffffff",
                              width: "48px",
                              height: "48px",
                              borderRadius: "50%",
                              fontWeight: "800",
                              fontSize: "20px",
                              boxShadow: isBeingDragged
                                ? "0 8px 20px rgba(24, 144, 255, 0.65)"
                                : "0 4px 12px rgba(24, 144, 255, 0.45)",
                              border: "3px solid #ffffff",
                              userSelect: "none",
                              cursor: isBeingDragged ? "grabbing" : "grab",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: isBeingDragged ? 20 : 10,
                              transition: isBeingDragged
                                ? "none"
                                : "transform 0.1s ease",
                            }}
                            title={tooltipText}
                          >
                            {ann.value}
                          </div>
                        );
                      }

                      if (ann.type === "remark") {
                        return (
                          <div
                            key={ann.id}
                            onMouseDown={(e) =>
                              handleAnnotationMouseDown(e, ann)
                            }
                            onTouchStart={(e) =>
                              handleAnnotationMouseDown(e, ann)
                            }
                            onClick={(e) => handleAnnotationClick(e, ann.id)}
                            style={{
                              position: "absolute",
                              left: `${ann.x}%`,
                              top: `${ann.y}%`,
                              transform: isBeingDragged
                                ? "translate(0, -50%) scale(1.08)"
                                : "translate(0, -50%)",
                              background: "#fef3c7",
                              color: "#78350f",
                              border: "2px solid #f59e0b",
                              padding: "8px 16px",
                              borderRadius: "10px",
                              fontSize: "15px",
                              fontWeight: "600",
                              boxShadow: isBeingDragged
                                ? "0 8px 20px rgba(245, 158, 11, 0.45)"
                                : "0 4px 12px rgba(245, 158, 11, 0.25)",
                              maxWidth: "280px",
                              wordBreak: "break-word",
                              userSelect: "none",
                              cursor: isBeingDragged ? "grabbing" : "grab",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              zIndex: isBeingDragged ? 20 : 10,
                              transition: isBeingDragged
                                ? "none"
                                : "transform 0.1s ease",
                            }}
                            title={tooltipText}
                          >
                            <span>💬 {ann.value}</span>
                            <span
                              style={{ color: "#b45309", fontWeight: "bold" }}
                            >
                              ✕
                            </span>
                          </div>
                        );
                      }

                      return null;
                    })}
                  </div>
                </div>
              );
            })
          ) : (
            <p
              style={{ color: "#64748b", marginTop: "40px", fontSize: "16px" }}
            >
              Answer Booklet Not Found
            </p>
          )}
        </div>

        {/* COLUMN 2 (8% Middle): Page Thumbnails Sidebar */}
        <div style={styles.column2}>
          <div style={{ textAlign: "center", marginBottom: "12px" }}>
            <h5 style={styles.thumbnailTitle}>Pages ({fileList.length})</h5>
            <span style={styles.thumbnailSubtitle}>Click to open</span>
          </div>

          <div style={styles.thumbnailList}>
            {fileList.map((el, i) => {
              const pageAnnCount = annotations.filter(
                (a) => a.imageIdentifier === el || a.pageIndex === i,
              ).length;
              const isActive = activePage === i;

              return (
                <div
                  key={i}
                  onClick={() => scrollToImage(i)}
                  style={{
                    ...styles.thumbnailCard,
                    border: isActive
                      ? "2px solid #2563eb"
                      : "1px solid #cbd5e1",
                    boxShadow: isActive
                      ? "0 4px 10px rgba(37, 99, 235, 0.25)"
                      : "0 1px 3px rgba(0,0,0,0.05)",
                  }}
                  title={`Click to open Page ${i + 1} (${el})`}
                >
                  <div style={styles.thumbnailImgWrapper}>
                    <img
                      src={
                        "https://answer-booklets.s3.ap-south-1.amazonaws.com/eval-img/" +
                        filepath +
                        el
                      }
                      alt={`Page ${i + 1} Thumbnail`}
                      style={styles.thumbnailImg}
                    />
                  </div>
                  <div
                    style={{
                      ...styles.thumbnailFooter,
                      background: isActive ? "#2563eb" : "#f8fafc",
                      color: isActive ? "#ffffff" : "#475569",
                    }}
                  >
                    <span>P{i + 1}</span>
                    {pageAnnCount > 0 && (
                      <span
                        style={{
                          fontSize: "9px",
                          background: isActive ? "#ffffff" : "#2563eb",
                          color: isActive ? "#2563eb" : "#ffffff",
                          padding: "1px 4px",
                          borderRadius: "8px",
                          fontWeight: "bold",
                        }}
                      >
                        {pageAnnCount}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* COLUMN 3 (25% Rightmost): Styled Table Card with Teal Top Accent Border */}
        <div style={styles.column3}>
          {/* Top Action Buttons Bar with Nice Colors */}
          <div style={styles.topActionBar}>
            <button
              type="button"
              onClick={handleOpenQp}
              style={styles.btnQp}
              title="Open Question Paper"
            >
              📄 QP
            </button>

            <button
              type="button"
              onClick={handleOpenScheme}
              style={styles.btnQp}
              title="Open Marking Scheme"
            >
              📋 Scheme
            </button>

            <button
              type="button"
              onClick={handleMarkNaForAll}
              style={styles.btnMarkNa}
              title="Mark 'N' for all unanswered/left-out questions"
            >
              ⚡ Mark NA All
            </button>

            <button
              type="button"
              onClick={handleCompleteValuation}
              style={styles.btnCompleteVal}
              title="Strike out entire page for all un-annotated pages"
            >
              ✨ Complete Val.
            </button>

            {timeLeft > 0 ? (
              <button
                type="button"
                onClick={() => handleSave("save")}
                style={{
                  ...styles.btnSave,
                  opacity: valuationProgressStats.isFullyComplete ? 1 : 0.65,
                  cursor: valuationProgressStats.isFullyComplete
                    ? "pointer"
                    : "not-allowed",
                }}
                title={
                  valuationProgressStats.isFullyComplete
                    ? "Save Final Evaluation"
                    : "Save requires 100% valuation completion"
                }
              >
                Save ({formatTime(timeLeft)})
              </button>
            ) : (
              <button
                type="button"
                onClick={() => handleSave("save")}
                style={{
                  ...styles.btnSave,
                  opacity: valuationProgressStats.isFullyComplete ? 1 : 0.65,
                  cursor: valuationProgressStats.isFullyComplete
                    ? "pointer"
                    : "not-allowed",
                }}
                title={
                  valuationProgressStats.isFullyComplete
                    ? "Save Final Evaluation"
                    : "Save requires 100% valuation completion"
                }
              >
                Save
              </button>
            )}

            <button
              type="button"
              onClick={() => handleSave("draft")}
              style={styles.btnDraft}
              title="Save Draft"
            >
              📝 Draft
            </button>

            <button
              type="button"
              onClick={() => setRejectOpen(true)}
              style={styles.btnReject}
              title="Reject Answer Script"
            >
              🚫 Reject
            </button>

            <button
              type="button"
              onClick={handleGoBack}
              style={styles.btnExit}
              title="Exit Evaluation"
            >
              ↩ Exit
            </button>
          </div>

          {/* Flexbox Card Container with Teal Accent Line */}
          <div style={styles.flexCardContainer}>
            {/* Header Block with Metadata Badge */}
            <div style={styles.tableCardHeader}>
              <div
                style={{
                  ...styles.tableCardMetaRow,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <span style={styles.tableCardMetaBadge}>
                  QP: <strong>{qpcode}</strong> | Reg:{" "}
                  <strong>{regcode}</strong> | Val: <strong>{valno}</strong>
                </span>

                {/* Small Eye Symbol to open Evaluation Guide Modal */}
                <button
                  type="button"
                  onClick={() => setGuideModalOpen(true)}
                  style={styles.btnEyeInfo}
                  title="How to Use Evaluation Screen & Guidelines"
                >
                  <Icon name="eye" style={{ margin: 0, fontSize: "11px" }} />
                </button>
              </div>
            </div>

            {/* Valuation Progress Bar Section */}
            <div
              style={{
                padding: "10px 14px",
                background: "#f8fafc",
                borderBottom: "1px solid #e2e8f0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "6px",
                  fontSize: "12px",
                  fontWeight: "700",
                }}
              >
                <span style={{ color: "#334155" }}>Valuation Progress</span>
                <span
                  style={{
                    color: valuationProgressStats.isFullyComplete
                      ? "#15803d"
                      : "#2563eb",
                    fontWeight: "800",
                  }}
                >
                  {valuationProgressStats.overallProgress}%{" "}
                  {valuationProgressStats.isFullyComplete && "✓ Complete"}
                </span>
              </div>

              {/* Progress Bar Track & Gradient Fill */}
              <div
                style={{
                  height: "8px",
                  width: "100%",
                  background: "#cbd5e1",
                  borderRadius: "6px",
                  overflow: "hidden",
                  marginBottom: "6px",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: `${valuationProgressStats.overallProgress}%`,
                    background: valuationProgressStats.isFullyComplete
                      ? "linear-gradient(90deg, #22c55e, #15803d)"
                      : "linear-gradient(90deg, #3b82f6, #2563eb)",
                    borderRadius: "6px",
                    transition: "width 0.3s ease-in-out",
                  }}
                />
              </div>

              {/* Progress Detail Badges */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "11px",
                  color: "#64748b",
                  fontWeight: "600",
                }}
              >
                <span>
                  Qns Evaluated: {valuationProgressStats.assessedQns}/
                  {valuationProgressStats.totalQns}
                </span>
                <span>
                  Pages Struck/Annotated:{" "}
                  {valuationProgressStats.annotatedPages}/
                  {valuationProgressStats.totalPages}
                </span>
              </div>
            </div>

            {/* Scrollable Questions Area using Pure Flex */}
            <div style={styles.flexScrollArea}>
              {/* Total Summary Bar */}
              <div style={styles.flexSummaryBar}>
                {/* <div style={styles.flexSummaryLeft}>
                  1st Val: <strong>{totalMarksAwarded}</strong> M <br />
                  OMR: <strong>{omrmarks || "-"}</strong>
                </div> */}
                <div style={styles.flexSummaryRight}>
                  Secured Marks:{" "}
                  <strong style={{ fontSize: "14px", color: "#15803d" }}>
                    {totalMarksAwarded} M
                  </strong>
                </div>
                {sessionStorage.getItem("univcode") == "051" ? (
                  <div style={styles.flexSummaryRight}>
                    {valno == 2 && (
                      <>
                        1st Val. Marks: {val1Marks} <br />
                      </>
                    )}
                    {omrmarks !== "" && <div>OMR Marks: {omrmarks}</div>}
                  </div>
                ) : (
                  <div style={styles.flexSummaryRight}>
                    {omrmarks !== "" && <div>OMR Marks: {omrmarks}</div>}
                  </div>
                )}
              </div>

              {/* Tabular Question Section: Question No | Max Marks | Marks Obtained */}
              <div
                style={{
                  width: "100%",
                  marginTop: "8px",
                  maxHeight: "calc(100vh - 300px)",
                  minHeight: "220px",
                  overflowY: "auto",
                  overflowX: "auto",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e1",
                  background: "#ffffff",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                }}
              >
                {parts.length > 0 ? (
                  parts.map((el) => {
                    const partQuestions = questions.filter(
                      (que) =>
                        que.fpartcode === el.fpartcode && que.fsubqn !== "T",
                    );
                    if (partQuestions.length === 0) return null;

                    return (
                      <div key={el.fpartcode || el.fpartdesc}>
                        {/* Section Header */}
                        <div
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 6,
                            padding: "8px 12px",
                            background: "#f1f5f9",
                            color: "#1e293b",
                            fontWeight: "800",
                            fontSize: "12px",
                            letterSpacing: "0.5px",
                            borderBottom: "1px solid #cbd5e1",
                            borderTop: "1px solid #cbd5e1",
                          }}
                        >
                          {el.fpartdesc}
                        </div>
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            textAlign: "left",
                          }}
                        >
                          <thead
                            style={{
                              position: "sticky",
                              top: "33px",
                              zIndex: 5,
                              background: "#f8fafc",
                              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                            }}
                          >
                            <tr
                              style={{
                                borderBottom: "1px solid #e2e8f0",
                                fontSize: "11px",
                                fontWeight: "700",
                                color: "#475569",
                                textTransform: "uppercase",
                              }}
                            >
                              <th
                                style={{
                                  padding: "8px 12px",
                                  background: "#f8fafc",
                                }}
                              >
                                Question No
                              </th>
                              <th
                                style={{
                                  padding: "8px 12px",
                                  textAlign: "center",
                                  background: "#f8fafc",
                                }}
                              >
                                Max Marks
                              </th>
                              <th
                                style={{
                                  padding: "8px 12px",
                                  textAlign: "right",
                                  background: "#f8fafc",
                                }}
                              >
                                Marks Obtained
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {partQuestions.map((que, index) =>
                              renderQnTableRow(que, index),
                            )}
                          </tbody>
                        </table>
                      </div>
                    );
                  })
                ) : (
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      textAlign: "left",
                    }}
                  >
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 5,
                        background: "#f8fafc",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      }}
                    >
                      <tr
                        style={{
                          borderBottom: "1px solid #e2e8f0",
                          fontSize: "11px",
                          fontWeight: "700",
                          color: "#475569",
                          textTransform: "uppercase",
                        }}
                      >
                        <th
                          style={{ padding: "8px 12px", background: "#f8fafc" }}
                        >
                          Question No
                        </th>
                        <th
                          style={{
                            padding: "8px 12px",
                            textAlign: "center",
                            background: "#f8fafc",
                          }}
                        >
                          Max Marks
                        </th>
                        <th
                          style={{
                            padding: "8px 12px",
                            textAlign: "right",
                            background: "#f8fafc",
                          }}
                        >
                          Marks Obtained
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {questions.map((que, index) => {
                        if (que.fsubqn === "T") return null;
                        return renderQnTableRow(que, index);
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Context Menu */}
      {contextMenu.visible && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "fixed",
            ...getContextMenuPosition(),
            zIndex: 10000,
            background: "#ffffff",
            borderRadius: "10px",
            boxShadow:
              "0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
            border: "1px solid #e2e8f0",
            padding: "6px 0",
            minWidth: "240px",
          }}
        >
          <div
            style={{
              padding: "10px 16px",
              borderBottom: "1px solid #f1f5f9",
              marginBottom: "4px",
            }}
          >
            <div
              style={{
                fontSize: "13px",
                fontWeight: "700",
                textTransform: "uppercase",
                color: "#2563eb",
                letterSpacing: "0.5px",
                marginBottom: "6px",
              }}
            >
              Select Target Question:
            </div>
            <select
              value={selectedQnCode}
              onChange={(e) => setSelectedQnCode(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 10px",
                borderRadius: "6px",
                border: "1px solid #93c5fd",
                fontSize: "15px",
                fontWeight: "700",
                color: "#1e3a8a",
                background: "#eff6ff",
                outline: "none",
                cursor: "pointer",
                marginBottom: "6px",
              }}
            >
              {questions.map((q) => {
                if (q.fsubqn === "T") return null;
                const code = getQnCode(q);
                return (
                  <option key={code} value={code}>
                    Question {code}{" "}
                    {q.fmaxmarks ? `(Max: ${q.fmaxmarks}m)` : ""}
                  </option>
                );
              })}
            </select>

            <div
              style={{
                fontSize: "12px",
                color: "#475569",
                fontWeight: "600",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "230px",
              }}
              title={contextMenu.imageIdentifier}
            >
              Image: <span>{contextMenu.imageIdentifier}</span>
            </div>
          </div>

          <div
            onClick={() => handleAddAnnotation("tick")}
            style={styles.menuItem}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#f0fdf4")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <span
              style={{ color: "#16a34a", fontSize: "22px", fontWeight: "bold" }}
            >
              ✓
            </span>
            <span>Tick</span>
          </div>

          <div
            onClick={() => handleAddAnnotation("strikeout")}
            style={styles.menuItem}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#fef2f2")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <span
              style={{ color: "#dc2626", fontSize: "22px", fontWeight: "bold" }}
            >
              ✗
            </span>
            <span>Strikeout</span>
          </div>

          <div
            onClick={() => handleAddAnnotation("strike_page")}
            style={styles.menuItem}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#fef2f2")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <span
              style={{ color: "#b91c1c", fontSize: "20px", fontWeight: "bold" }}
            >
              🗴
            </span>
            <span>Strike Entire Page</span>
          </div>

          <div
            onClick={() => handleAddAnnotation("marks")}
            style={styles.menuItem}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#eff6ff")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <span style={{ color: "#2563eb", fontSize: "20px" }}>🔢</span>
            <span>Add Marks (Qn {selectedQnCode})</span>
          </div>

          <div
            onClick={() => handleAddAnnotation("remark")}
            style={styles.menuItem}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#fffbeb")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <span style={{ color: "#d97706", fontSize: "20px" }}>💬</span>
            <span>Adding Remarks</span>
          </div>

          <div
            style={{
              height: "1px",
              background: "#f1f5f9",
              margin: "4px 0",
            }}
          />

          {/* <div
            onClick={handleRemoveAnnotation}
            style={styles.menuItem}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <span style={{ color: "#64748b", fontSize: "16px" }}>🗑️</span>
            <span style={{ color: "#ef4444", fontWeight: "500" }}>
              {contextMenu.targetAnnotationId
                ? "Remove Selected Annotation"
                : "Remove Annotation"}
            </span>
          </div> */}
        </div>
      )}

      {/* Input Modal for Marks / Remarks */}
      {inputModal.visible && (
        <div
          style={styles.modalBackdrop}
          onClick={() => setInputModal({ ...inputModal, visible: false })}
        >
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h3
              style={{
                margin: "0 0 4px 0",
                fontSize: "18px",
                color: "#0f172a",
              }}
            >
              {inputModal.title}
            </h3>
            <p
              style={{
                margin: "0 0 16px 0",
                fontSize: "12px",
                color: "#64748b",
              }}
            >
              Image Identifier: <strong>{inputModal.imageIdentifier}</strong>
            </p>
            <form onSubmit={handleModalSubmit}>
              {inputModal.type === "marks" ? (
                <div style={{ marginBottom: "20px" }}>
                  <label
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",
                      color: "#475569",
                      display: "block",
                      marginBottom: "6px",
                    }}
                  >
                    Select Marks (0.5 to{" "}
                    {selectedQuestion ? selectedQuestion.fmaxmarks : "Max"}):
                  </label>
                  <select
                    value={inputModal.value}
                    onChange={(e) =>
                      setInputModal({ ...inputModal, value: e.target.value })
                    }
                    style={{
                      width: "100%",
                      padding: "10px 14px",
                      borderRadius: "6px",
                      border: "1px solid #cbd5e1",
                      fontSize: "15px",
                      fontWeight: "700",
                      color: "#0f172a",
                      outline: "none",
                      boxSizing: "border-box",
                      marginBottom: "12px",
                      background: "#ffffff",
                      cursor: "pointer",
                    }}
                  >
                    <option value="">
                      -- Choose Marks for Qn {selectedQnCode} --
                    </option>
                    {selectedQuestionOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>

                  {/* Quick Select Option Pills */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "6px",
                      maxHeight: "130px",
                      overflowY: "auto",
                      padding: "4px",
                      background: "#f8fafc",
                      borderRadius: "8px",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    {selectedQuestionOptions.map((opt) => {
                      const isSelected = inputModal.value === opt.value;
                      return (
                        <button
                          key={opt.value}
                          type="button"
                          onClick={() =>
                            setInputModal({ ...inputModal, value: opt.value })
                          }
                          style={{
                            padding: "6px 12px",
                            borderRadius: "16px",
                            border: isSelected
                              ? "2px solid #2563eb"
                              : "1px solid #cbd5e1",
                            background: isSelected ? "#2563eb" : "#ffffff",
                            color: isSelected ? "#ffffff" : "#0f172a",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor: "pointer",
                            transition: "all 0.15s ease",
                            boxShadow: isSelected
                              ? "0 2px 6px rgba(37,99,235,0.3)"
                              : "none",
                          }}
                        >
                          {opt.value}
                        </button>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <input
                  type="text"
                  autoFocus
                  placeholder={inputModal.placeholder}
                  value={inputModal.value}
                  onChange={(e) =>
                    setInputModal({ ...inputModal, value: e.target.value })
                  }
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: "6px",
                    border: "1px solid #cbd5e1",
                    fontSize: "15px",
                    outline: "none",
                    boxSizing: "border-box",
                    marginBottom: "20px",
                  }}
                />
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                <button
                  type="button"
                  onClick={() =>
                    setInputModal({ ...inputModal, visible: false })
                  }
                  style={{
                    padding: "8px 16px",
                    borderRadius: "6px",
                    border: "1px solid #cbd5e1",
                    background: "#f8fafc",
                    color: "#475569",
                    cursor: "pointer",
                    fontWeight: "500",
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    padding: "8px 18px",
                    borderRadius: "6px",
                    border: "none",
                    background: "#2563eb",
                    color: "#ffffff",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
                  Add Annotation
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <Modal open={finalOpen} size="large">
        <Container style={{ padding: "1em" }}>
          <Card fluid style={{ padding: "1em" }}>
            <Card.Content textAlign="center">
              <Card.Header>Final Submission</Card.Header>
            </Card.Content>
            {evalData.length > 0 ? (
              <Table basic style={{ width: "40vw", margin: "10px auto" }}>
                <Table.Body>
                  {sum.length > 0 ? (
                    <Table.Row>
                      <Table.Cell>Evaluator Code</Table.Cell>
                      <Table.Cell>{sum[0].fteachcode}</Table.Cell>
                      <Table.Cell>Evaluator Name</Table.Cell>
                      <Table.Cell>{sum[0].fteachname}</Table.Cell>
                    </Table.Row>
                  ) : null}
                  <Table.Row>
                    <Table.Cell>QP Code</Table.Cell>
                    <Table.Cell>{row.fqpcode}</Table.Cell>
                    <Table.Cell>Subject Name</Table.Cell>
                    <Table.Cell>{row.fsubname}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Reg. Code</Table.Cell>
                    <Table.Cell>{row.fregcode}</Table.Cell>
                    <Table.Cell>Max. Marks</Table.Cell>
                    <Table.Cell>{row.ftempmax}</Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            ) : null}

            {evalData.length > 0 ? (
              <Table
                compact
                celled
                structured
                style={{ width: "40vw", margin: "10px auto" }}
              >
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell textAlign="center" rowSpan="2">
                      Qn. No.
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" colSpan="3">
                      Marks
                    </Table.HeaderCell>
                  </Table.Row>
                  <Table.Row>
                    <Table.HeaderCell textAlign="center">
                      Awarded by Evaluator
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Allocated by System
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Max. Marks
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                {partsData.map((el) => {
                  return (
                    <Table.Body key={el.fpartcode}>
                      <Table.Row positive key={el.fpartcode}>
                        <Table.Cell colSpan="4" textAlign="center">
                          {el.fpartdesc} (Answer {el.fmandqn} / {el.fmaxqn}{" "}
                          questions)
                        </Table.Cell>
                      </Table.Row>
                      {evalData.map((row) => {
                        if (
                          el.fpartcode == row.fpartcode &&
                          row.fsubqn != "T"
                        ) {
                          return (
                            <Table.Row key={row.fqncode}>
                              <Table.Cell textAlign="center">
                                {row.fqnno}
                              </Table.Cell>
                              <Table.Cell textAlign="center">
                                {parseFloat(row.fmarks11) == -2
                                  ? "NA"
                                  : parseFloat(row.fmarks11)}
                              </Table.Cell>
                              <Table.Cell textAlign="center">
                                {parseFloat(row.fmarks12) == -2
                                  ? "NA"
                                  : row.fmarks12 == ""
                                  ? ""
                                  : parseFloat(row.fmarks12)}
                              </Table.Cell>
                              <Table.Cell textAlign="center">
                                {parseFloat(row.fmaxmarks)}
                              </Table.Cell>
                            </Table.Row>
                          );
                        }
                      })}
                      <Table.Row warning key={el.fpartcode + 1}>
                        <Table.Cell textAlign="center">Part Total</Table.Cell>
                        <Table.Cell textAlign="center">
                          {parseFloat(el.fmarks11)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {parseFloat(el.fmarks12)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {parseFloat(el.fmaxmarks)}
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  );
                })}

                {sumData.length > 0 ? (
                  <Table.Footer>
                    <Table.Row>
                      <Table.HeaderCell textAlign="center">
                        Final Marks
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        {parseFloat(sum[0].ftotmarks)}
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        {parseFloat(sum[0].fsysmarks)}
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        {parseFloat(row.ftempmax)}
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Footer>
                ) : null}
              </Table>
            ) : null}

            <center>
              {sumData.length ? (
                <div>
                  <Checkbox
                    label="I acknowledge that above Allocted marks are found correct and any further modification is not allowed."
                    onChange={(e, data) => {
                      setAck(data.checked);
                    }}
                  />
                  <br />
                  <br />

                  <TextArea
                    placeholder="Remarks (optional)"
                    style={{
                      width: "65%",
                      border: "1px solid #999",
                      borderRadius: "4px",
                    }}
                    rows={4}
                    value={remarks}
                    onChange={(e, data) => setRemarks(data.value)}
                  />
                  <br />
                  <br />
                  <Button
                    size="tiny"
                    icon="arrow alternate circle left outline"
                    color="red"
                    onClick={() => setFinalOpen(false)}
                    style={{ marginRight: "1em" }}
                    content="Cancel"
                  />

                  <Button
                    primary
                    size="tiny"
                    icon="save outline"
                    onClick={finalsubmitEvalaution}
                    disabled={!ack || timeLeft > 0}
                    content="Final Submit"
                  />

                  <br />
                </div>
              ) : null}
            </center>
          </Card>
        </Container>
      </Modal>

      {/* Modal: How to Use Evaluation Screen & Notes */}
      <Modal
        open={guideModalOpen}
        onClose={() => setGuideModalOpen(false)}
        size="small"
        closeIcon
        style={{ borderRadius: "12px", overflow: "hidden" }}
      >
        <Modal.Header
          style={{
            background: "#f8fafc",
            borderBottom: "1px solid #e2e8f0",
            color: "#1e293b",
            fontSize: "16px",
            fontWeight: "800",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span style={{ fontSize: "18px" }}>ℹ️</span>
          <span>How to Use Evaluation Screen</span>
        </Modal.Header>
        <Modal.Content
          style={{
            padding: "20px 24px",
            fontSize: "13px",
            lineHeight: "1.6",
            color: "#334155",
          }}
        >
          <div style={{ marginBottom: "16px" }}>
            <h4
              style={{
                margin: "0 0 10px 0",
                fontSize: "14px",
                fontWeight: "700",
                color: "#2563eb",
              }}
            >
              Evaluation Instructions:
            </h4>
            <ul
              style={{
                margin: "0 0 0 18px",
                padding: 0,
                color: "#334155",
                lineHeight: "1.8",
              }}
            >
              <li>
                Select a <b>Question Badge</b> before adding annotations or
                marks.
              </li>
              <li>
                <b>Right-Click</b> on booklet pages to add <b>Tick (✓)</b>,{" "}
                <b>Strikeout (✗)</b>, <b>Marks</b>, or <b>Remarks</b>.
              </li>
              <li>
                Assigning marks <b>&gt; 0</b> auto-adds a <b>Tick (✓)</b>.
                Assigning <b>0</b> marks auto-adds a <b>Strikeout (✗)</b>.
              </li>
              <li>
                Use <b>⚡ Mark NA All</b> button to auto-fill <b>'N'</b> for all
                unanswered questions.
              </li>
              <li>
                Use <b>✨ Complete Valuation</b> to auto-strikeout all
                un-annotated pages.
              </li>
            </ul>
          </div>

          {/* Note Callout */}
          <div
            style={{
              background: "#fff1f2",
              border: "1px solid #fecdd3",
              borderRadius: "8px",
              padding: "12px 16px",
              marginTop: "16px",
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
            }}
          >
            <span style={{ fontSize: "18px", lineHeight: "1.2" }}>📌</span>
            <div>
              <b style={{ color: "#dc2626", fontSize: "13px" }}>Note: </b>
              <span
                style={{
                  color: "#9f1239",
                  fontWeight: "600",
                  fontSize: "13px",
                }}
              >
                If student has not answered any question, put 'N' instead of
                marks.
              </span>
            </div>
          </div>
        </Modal.Content>
        <Modal.Actions
          style={{
            background: "#f8fafc",
            borderTop: "1px solid #e2e8f0",
            padding: "12px 20px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            primary
            size="small"
            onClick={() => setGuideModalOpen(false)}
            style={{ borderRadius: "6px", fontWeight: "600" }}
          >
            Got it
          </Button>
        </Modal.Actions>
      </Modal>
      <Modal open={rejectOpen} size="small">
        <Modal.Header>
          Answer Script Rejection
          <Button
            onClick={() => setRejectOpen(false)}
            secondary
            floated="right"
          >
            <Icon name="close" />
            Close
          </Button>
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <Form>
              <Message negative>
                <Message.Header>
                  <Radio
                    fitted
                    name="rejectAb"
                    value="Script Re-scan request"
                    checked={arReason == "Script Re-scan request"}
                    label="Script Re-scan request"
                    onChange={(e, data) => setArReason(data.value)}
                  />
                </Message.Header>
                <p style={{ textIndent: "3ch" }}>
                  I am unable to mark candidate's answer scripts because of poor
                  scannig quality
                </p>
              </Message>
              <Message negative>
                <Message.Header>
                  <Radio
                    fitted
                    name="rejectAb"
                    value="Malpractice Concern"
                    checked={arReason == "Malpractice Concern"}
                    label="Malpractice Concern"
                    onChange={(e, data) => setArReason(data.value)}
                  />
                </Message.Header>
                <p style={{ textIndent: "3ch" }}>
                  I suspected malpractice in connection to this answer script. I
                  want this to be reviewed
                </p>
              </Message>

              <Message negative>
                <Message.Header>
                  <Radio
                    fitted
                    name="rejectAb"
                    value="Wrong QP Pattern"
                    label="Wrong QP Pattern"
                    checked={arReason == "Wrong QP Pattern"}
                    onChange={(e, data) => setArReason(data.value)}
                  />
                </Message.Header>
                <p style={{ textIndent: "3ch" }}>
                  Displayed marks pattern does not match with the question
                  paper.
                </p>
              </Message>

              <Message negative>
                <Message.Header>
                  <Radio
                    fitted
                    name="rejectAb"
                    value="Answer Script Mismatch with QP"
                    label="Answer Script Mismatch with QP"
                    checked={arReason == "Answer Script Mismatch with QP"}
                    onChange={(e, data) => setArReason(data.value)}
                  />
                </Message.Header>
                <p style={{ textIndent: "3ch" }}>
                  Displayed answer script does not match the subject.
                </p>
              </Message>
              <Message negative>
                <Message.Header>
                  <Radio
                    fitted
                    name="rejectAb"
                    value="Student Identity revealed"
                    label="Student Identity revealed"
                    checked={arReason == "Student Identity revealed"}
                    onChange={(e, data) => setArReason(data.value)}
                  />
                </Message.Header>
                <p style={{ textIndent: "3ch" }}>
                  Student Identity is revealed.
                </p>
              </Message>
              <Form.TextArea
                label="Comment"
                placeholder="Comment..."
                value={arComment}
                onChange={(e, data) => setArComment(data.value)}
              />
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions style={{ textAlign: "center" }}>
          <Button onClick={() => saveEvalReject()} primary>
            Submit
          </Button>
        </Modal.Actions>
      </Modal>
      <Modal open={qnModal != ""} size="medium">
        <Modal.Header>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h4>Questions</h4>
            <Button
              onClick={() => {
                setQnModal("");
              }}
              secondary
              // floated="right"
            >
              Close
            </Button>
          </div>
        </Modal.Header>

        <Modal.Content scrolling>
          {qnModal == "questions" &&
            questions.map((q, index) => (
              <div
                key={index}
                style={{
                  marginBottom: "20px",
                  lineHeight: "1.6",
                }}
              >
                <strong>{q.fqnno}.)</strong>

                <div
                  dangerouslySetInnerHTML={{
                    __html: q.fquestion,
                  }}
                />
              </div>
            ))}

          {qnModal == "answers" &&
            questions.map((q, index) => (
              <div
                key={index}
                style={{
                  marginBottom: "20px",
                  lineHeight: "1.6",
                }}
              >
                <strong>{q.fqnno}.)</strong>

                <div
                  dangerouslySetInnerHTML={{
                    __html: q.fkeyans,
                  }}
                />
              </div>
            ))}
        </Modal.Content>
      </Modal>
    </div>
  );
};

// Reusable Style Objects matching User Image Exact Aesthetic
const styles = {
  container: {
    position: "relative",
    minHeight: "100vh",
    background: "#f8fafc",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  mainLayout: {
    display: "flex",
    width: "100%",
    minHeight: "100vh",
  },
  // Column 1 (67% Center Viewer)
  column1: {
    width: "67%",
    flex: "0 0 67%",
    padding: "16px",
    boxSizing: "border-box",
    borderRight: "1px solid #cbd5e1",
    background: "#f8fafc",
    overflowX: "auto",
  },
  pageContainer: {
    position: "relative",
    marginBottom: "28px",
    width: "100%",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    overflow: "visible",
    background: "#ffffff",
    border: "1px solid #e2e8f0",
  },
  floatingToolbar: {
    position: "absolute",
    top: "12px",
    right: "12px",
    zIndex: 50,
    display: "flex",
    alignItems: "center",
    gap: "4px",
    background: "rgba(15, 23, 42, 0.85)",
    backdropFilter: "blur(6px)",
    padding: "4px 8px",
    borderRadius: "6px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
  },
  toolbarBtn: {
    background: "rgba(255, 255, 255, 0.15)",
    color: "#ffffff",
    border: "1px solid rgba(255, 255, 255, 0.25)",
    borderRadius: "4px",
    padding: "3px 8px",
    fontSize: "12px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.15s ease",
  },
  toolbarResetBtn: {
    background: "#dc2626",
    color: "#ffffff",
    border: "1px solid #f87171",
    borderRadius: "4px",
    padding: "3px 8px",
    fontSize: "12px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.15s ease",
  },
  toolbarBadge: {
    fontSize: "11px",
    color: "#f8fafc",
    fontWeight: "600",
    paddingLeft: "4px",
    minWidth: "50px",
    textAlign: "right",
  },
  // Column 2 (8% Thumbnails)
  column2: {
    width: "8%",
    flex: "0 0 8%",
    background: "#ffffff",
    padding: "12px 4px",
    boxSizing: "border-box",
    borderRight: "1px solid #cbd5e1",
    position: "sticky",
    top: 0,
    height: "100vh",
    overflowY: "auto",
  },
  thumbnailTitle: {
    margin: "0 0 2px 0",
    fontSize: "11px",
    color: "#475569",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  thumbnailSubtitle: {
    fontSize: "9px",
    color: "#94a3b8",
  },
  thumbnailList: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  thumbnailCard: {
    position: "relative",
    borderRadius: "6px",
    overflow: "hidden",
    cursor: "pointer",
    background: "#ffffff",
    transition: "all 0.15s ease",
  },
  thumbnailImgWrapper: {
    height: "80px",
    overflow: "hidden",
    background: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  thumbnailImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  thumbnailFooter: {
    padding: "3px 4px",
    fontSize: "10px",
    fontWeight: "600",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  // Column 3 (25% Exact Table Card matching Screenshot)
  column3: {
    width: "25%",
    flex: "0 0 25%",
    background: "#ffffff",
    padding: "0 0 10px 0",
    boxSizing: "border-box",
    position: "sticky",
    top: 0,
    height: "100vh",
    overflowY: "auto",
    boxShadow: "-2px 0 10px rgba(0,0,0,0.03)",
  },
  topActionBar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "10px",
    padding: "8px 10px",
    background: "#f8fafc",
    borderBottom: "1px solid #e2e8f0",
  },
  btnQp: {
    background: "#008dda", // Project Primary Blue
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "6px 10px",
    fontSize: "12px",
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(0, 141, 218, 0.3)",
    transition: "all 0.15s ease",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "30px",
    boxSizing: "border-box",
    lineHeight: "1",
  },
  btnScheme: {
    background: "#00b5ad", // Project Teal Accent
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "6px 10px",
    fontSize: "12px",
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(0, 181, 173, 0.3)",
    transition: "all 0.15s ease",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "30px",
    boxSizing: "border-box",
    lineHeight: "1",
  },
  btnMarkNa: {
    background: "#7c3aed", // Vibrant Purple
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(124, 58, 237, 0.3)",
    transition: "all 0.15s ease",
    display: "inline-flex",
    alignItems: "center",
  },
  btnCompleteVal: {
    background: "#0284c7", // Vibrant Sky Blue
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(2, 132, 199, 0.3)",
    transition: "all 0.15s ease",
    display: "inline-flex",
    alignItems: "center",
  },
  btnSave: {
    background: "#21ba45", // Project Positive Green
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(33, 186, 69, 0.3)",
    transition: "all 0.15s ease",
    display: "inline-flex",
    alignItems: "center",
  },
  btnDraft: {
    background: "#f2711c", // Project Orange Warning
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(242, 113, 28, 0.3)",
    transition: "all 0.15s ease",
    display: "inline-flex",
    alignItems: "center",
  },
  btnReject: {
    background: "#db2828", // Project Negative Red
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(219, 40, 40, 0.3)",
    transition: "all 0.15s ease",
    display: "inline-flex",
    alignItems: "center",
  },
  btnExit: {
    background: "#767676", // Project Secondary Gray
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(118, 118, 118, 0.3)",
    transition: "all 0.15s ease",
    display: "inline-flex",
    alignItems: "center",
  },
  btnGuide: {
    background: "#0284c7",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "7px 10px",
    fontSize: "12px",
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(2, 132, 199, 0.3)",
    transition: "all 0.15s ease",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
  },
  btnEyeInfo: {
    background: "#eff6ff",
    color: "#2563eb",
    border: "1px solid #93c5fd",
    borderRadius: "50%",
    width: "22px",
    height: "22px",
    padding: 0,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.15s ease",
    boxShadow: "0 1px 2px rgba(37, 99, 235, 0.15)",
  },
  flexCardContainer: {
    background: "#ffffff",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    borderTop: "4px solid #0d9488",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    overflow: "hidden",
    // margin: "8px 6px",
    display: "flex",
    flexDirection: "column",
  },
  tableCardHeader: {
    background: "#f8fafc",
    padding: "0px 16px 6px 16px",
    textAlign: "center",
    borderBottom: "1px solid #e2e8f0",
  },
  tableCardTitle: {
    margin: 0,
    fontSize: "17px",
    fontWeight: "800",
    color: "#0f172a",
    letterSpacing: "-0.01em",
  },
  tableCardMetaRow: {
    marginTop: "6px",
  },
  tableCardMetaBadge: {
    fontSize: "11px",
    color: "#0f766e",
    background: "#ccfbf1",
    padding: "3px 10px",
    borderRadius: "12px",
    fontWeight: "600",
    display: "inline-block",
    border: "1px solid #99f6e4",
  },
  flexScrollArea: {
    maxHeight: "calc(100vh - 160px)",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
  },
  flexNoteBanner: {
    background: "#fff1f2",
    color: "#9f1239",
    padding: "8px 12px",
    fontSize: "11px",
    borderBottom: "1px solid #fecdd3",
  },
  flexSummaryBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "#f0fdf4",
    color: "#166534",
    padding: "8px 12px",
    borderBottom: "1px solid #bbf7d0",
    fontSize: "12px",
  },
  flexSummaryLeft: {
    fontWeight: "600",
  },
  flexSummaryRight: {
    fontWeight: "700",
  },
  flexPartGroup: {
    display: "flex",
    flexDirection: "column",
  },
  flexPartHeader: {
    background: "#f1f5f9",
    padding: "6px 12px",
    fontSize: "12px",
    fontWeight: "700",
    color: "#334155",
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    borderTop: "1px solid #e2e8f0",
    borderBottom: "1px solid #e2e8f0",
  },
  flexQnGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    padding: "12px 10px",
    background: "#ffffff",
  },
  qnBadgeCard: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 12px",
    borderRadius: "6px",
    background: "#ffffff",
    border: "1px solid #cbd5e1",
    color: "#334155",
    fontWeight: "700",
    fontSize: "13px",
    cursor: "pointer",
    transition: "all 0.15s ease",
  },
  qnBadgeActiveCard: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 12px",
    borderRadius: "6px",
    background: "#2563eb",
    border: "1px solid #1d4ed8",
    color: "#ffffff",
    fontWeight: "800",
    fontSize: "13px",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(37, 99, 235, 0.3)",
    transition: "all 0.15s ease",
  },
  qnMarkTag: {
    background: "#e2e8f0",
    color: "#0f172a",
    fontSize: "11px",
    fontWeight: "bold",
    padding: "2px 6px",
    borderRadius: "10px",
  },
  qnMarkTagActive: {
    background: "#ffffff",
    color: "#2563eb",
    fontSize: "11px",
    fontWeight: "bold",
    padding: "2px 6px",
    borderRadius: "10px",
  },
  menuItem: {
    padding: "10px 18px",
    display: "flex",
    alignItems: "center",
    gap: "14px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    color: "#334155",
    transition: "background 0.15s ease",
  },
  modalBackdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(15, 23, 42, 0.4)",
    backdropFilter: "blur(3px)",
    zIndex: 11000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    background: "#ffffff",
    borderRadius: "12px",
    padding: "24px",
    width: "90%",
    maxWidth: "400px",
    boxShadow:
      "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e2e8f0",
  },
};

export default OnlineMarksDigiVal;
